

































import { Component, Vue, Prop } from 'vue-property-decorator'
import { Room } from '@/class/room'
import { RoomStorage } from '@/class/roomStorage'
import AllRoleGuide from '@/components/AllRoleGuide.vue'
import RoomMemberList from '@/components/RoomMemberList.vue'
import Advertisement from '@/components/Common/Advertisement.vue'
import HeadlineBorder from '@/components/Utils/headline/HeadlineBorder.vue'
import BoxNotchFrame from '@/components/Utils/box/BoxNotchFrame.vue'
import BtnSquare from '@/components/Utils/form/button/BtnSquare.vue'
import InputText from '@/components/Utils/form/text/InputText.vue'

@Component({
  components: {
    AllRoleGuide,
    RoomMemberList,
    Advertisement,
    HeadlineBorder,
    BoxNotchFrame,
    BtnSquare,
    InputText
  }
})
export default class Join extends Vue {
  @Prop() roomId!: string;
  room = new Room(this.roomId);
  roomStorage = new RoomStorage(this.roomId);
  isProcessing = false;

  newMemberName = '';

  created () {
    if (this.roomStorage.roomMemberId) {
      this.$router.push({ name: 'player', params: { roomId: this.roomId, playerId: this.roomStorage.roomMemberId } })
    } else {
      this.$watch('isStandBy', (now) => {
        if (!now) {
          this.$router.replace({ name: 'gallary', params: { roomId: this.roomId } })
        }
      })
    }
  }

  get isLoading () {
    return this.room.isLoading
  }

  get isStandBy () {
    return this.room.isStandBy
  }

  async join () {
    if (this.isProcessing) return

    this.isProcessing = true
    const memberId = await this.room.addRoomMember(this.newMemberName)
    this.roomStorage.saveRoomMemberId(memberId)
    this.$router.push({ name: 'player', params: { roomId: this.roomId, playerId: memberId } })
  }
}
